import { Grid, Paper } from "@mui/material";
import React from "react";
import BoxesSummaryCount from "./BoxesSummaryCount";
import BoxesSummaryProgress from "./BoxesSummaryProgress";

export default function BoxesSummary({
  data = [],
  summary = {},
  progress = {},
}) {
  return (
    <div>
      <Paper className="p-5">
        <Grid container alignItems="stretch">
          <Grid
            item
            lg={3}
            md={3}
            sm={4}
            xs={12}
            className="border-r border-white-gray"
          >
            <BoxesSummaryCount summary={summary} data={data} />
          </Grid>
          <Grid item flexGrow={1}>
            <BoxesSummaryProgress
              progress={progress}
              data={data}
              progressType="overview"
            />
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
